import styled from 'styled-components';

import { SHeaderCell } from '../Table.styles';

export const StyledOrderableHeaderCell = styled(SHeaderCell)`
  cursor: pointer;
  user-select: none;
`;
